import { Tax } from '@src/types/Tax'
import { ApiRes, api } from './client'

export type TaxesResponse = {
    success: boolean
    taxes: Tax[]
    taxes_count: number
}

export type TaxResponse = {
    success: boolean
    tax: Tax
}

export type TaxNamePlaceholdersResponse = {
    success: boolean
    name_placeholders: string[]
}

export const storeTax = (tax: Tax): ApiRes<TaxResponse> => {
    return api.post('manage/taxes', tax)
}

export const getTaxes = (): ApiRes<TaxesResponse> => {
    return api.get('manage/taxes')
}

export const getTax = (id: string): ApiRes<TaxResponse> => {
    return api.get(`manage/taxes/${id}`)
}

export const getTaxNamePlaceholders =
    (): ApiRes<TaxNamePlaceholdersResponse> => {
        return api.get('manage/taxes/name-placeholders')
    }

export const updateTax = (
    id: string,
    tax: Partial<Tax>
): ApiRes<TaxResponse> => {
    return api.put(`manage/taxes/${id}`, tax)
}

export const deleteTax = (id: string): ApiRes<null> => {
    return api.delete(`manage/taxes/${id}`)
}
